import { useCallback, useState } from "react";
import { API } from "../data/siteData";
import { csrfHeaders } from "../utils/csrf";

export default function useLeadPipeline(onRefresh) {
  const [savingLeadId, setSavingLeadId] = useState("");
  const [savedLeadId, setSavedLeadId] = useState("");
  const [error, setError] = useState("");

  const updateStatus = useCallback(
    async (lead, status) => {
      if (status === lead.status) return;
      setError("");
      setSavedLeadId("");
      setSavingLeadId(lead.lead_id);
      try {
        const response = await fetch(`${API}/admin/leads/${lead.lead_id}/pipeline`, {
          method: "PATCH",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            ...csrfHeaders(),
          },
          body: JSON.stringify({ status }),
        });
        if (!response.ok) throw new Error("Pipeline update failed.");
        setSavedLeadId(lead.lead_id);
        await onRefresh();
      } catch {
        setError("The pipeline stage could not be updated. Please try again.");
      } finally {
        setSavingLeadId("");
      }
    },
    [onRefresh],
  );

  return {
    error,
    savedLeadId,
    savingLeadId,
    updateStatus,
  };
}